export function session(state = {}, action) {
	switch (action.type) {
		case 'USER_UPDATE':
			return action.session || state
		case 'REVOKE_SESSION':
			return {}
		case 'STRAVA_UPDATE':
			return { ...state, externals: { strava: action.response } }
	}
	return state
}

export function strava(state = { pages: {}, activity: {} }, action) {
	switch (action.type) {
		case 'STRAVA_UPDATE': {
			return action.session || state
		}
		case 'PAGES_FETCH_SUCCESS': {
			const { response, query } = action
			return { ...state, pages: { ...state.pages, [query]: (response || []) } }
		}
		case 'PAGE_FETCH_ERROR': {
			return state
		}
		case 'ACTIVITY_FETCH_SUCCESS': {
			const { response, query } = action
			return { ...state, activity: { ...state.activity, [query]: (response || {}) } }
		}
	}
	return state
}



// WEBPACK FOOTER //
// ./src/store/reducers/userReducer.js